// extracted by mini-css-extract-plugin
export default {"container":"UETA_vRV7IBhjBCed7Wl"};